import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './pages/Services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,private authService: AuthService,) {}

  // canActivate(): boolean {
  //   const token = localStorage.getItem("token"); // یا هر روش احراز هویت
  //   if (!token) {
  //     this.router.navigate(['/login']);
  //     return false;
  //   }
  //   return true;
  // }

  //  canActivate(): boolean {
  //   if (this.authService.isLoggedIn() && this.authService.isAdmin()) {
  //     return true;
  //   }

  //   this.router.navigate(['/home']);
  //   return false;
  // }

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  const expectedRoles = route.data['roles'] as string[];
  const userRole = this.authService.getRole();

  if (!userRole) {
    this.router.navigate(['/login']);
    return false;
  }

  // اگر نقش کاربر مجموعه‌ای باشد (آرایه‌ای از نقش‌ها)
  if (Array.isArray(userRole)) {
    const hasRole = userRole.some(role => expectedRoles.includes(role));
    if (hasRole) return true;
  }

  // اگر فقط یک نقش باشد
  if (typeof userRole === 'string' && expectedRoles.includes(userRole)) {
    return true;
  }

  // نقش مجاز نبود
  this.router.navigate(['/home']);
  return false;
}


//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
//   const user = JSON.parse(localStorage.getItem('user') || '{}');

//   if (user?.role === 'admin') return true;

//   this.router.navigate(['/login']);
//   return false;
// }

}
